import { AccountPurchase } from '../models/account-purchase';

type Customer = Pick<AccountPurchase, 'customerAccount' | 'deliveryAddress'>;

/** The delivery address by its title, or by street and place where it has none. */
const addressLabel = (address?: AccountPurchase['deliveryAddress']): string | undefined =>
    address?.title ||
    [
        [address?.street, address?.number].filter(Boolean).join(' '),
        [address?.zip, address?.city].filter(Boolean).join(' '),
    ]
        .filter(Boolean)
        .join(', ') ||
    undefined;

/**
 * A customer of the inquiry by its name and its delivery address, readable
 * on the closed card. Two cards of the same member differed by street and
 * city alone (R-221).
 */
export const customerLabel = (purchase?: Customer): string | undefined =>
    [purchase?.customerAccount?.name, addressLabel(purchase?.deliveryAddress)].filter(Boolean).join(' · ') || undefined;

/**
 * The short name in the bar of customers: the address title where the same
 * member comes more than once — the cut-off name read the same in both
 * chips — and the name everywhere else.
 */
export const customerChipLabel = (purchase: Customer, all: Customer[]): string | undefined => {
    const memberId = purchase.customerAccount?.id;
    const repeated = undefined !== memberId && all.filter(other => other.customerAccount?.id === memberId).length > 1;
    const address = purchase.deliveryAddress;

    return repeated
        ? address?.title ||
              [address?.street, address?.city].filter(Boolean).join(', ') ||
              purchase.customerAccount?.name
        : purchase.customerAccount?.name;
};
